
import XhrModel from './../zviz2/zviz/xhrmodel';
import config from './../config';

import state from './../zviz2/zviz/state';

let searchFields = [
    'theme_category', 'theme', 'country', 'tc_symbol', 'eval_id',
    'doc_title', 'sta_desc','eval_manager', 'administrative_unit',
    'funding_source', 'tech_unit', 'regional_project_countries',
    'eval_title', 'll_desc', 'gp_desc', 'rec_desc'
];


class AppModel extends XhrModel{

    constructor(name=null, settings={}){
        super(name, settings);
    }
    
    getSelect(){
        let input = {};
        input['filter'] = this.processFilter(state.get('filter'));
        this.processSearch(input, state.get('filter'));

        return input;
    }

    processFilterOld(filter){
        let result = [];
        if(filter){

            // convert filter object to an array in form: 
            // [ [key, [...values] ], [key2, [...values] ] ]
            if(! (filter instanceof Array)){
                let filarr = [];
                for(let key of Object.keys(filter)){
                    if(key.length > 6 && key.substring(0, 6) == 'group/'){

                        let value = this.processFilter(filter[key]['filters']);
                        filarr.push([key, value, 'GROUP.' + filter[key]['separator']]);
                        continue;
                    }
                    let value = filter[key];
                    if(! (value instanceof Array)){
                        value = [value];
                    }
                    filarr.push([key, value]);
                }
                result = filarr;
            }else{
                result = filter.slice(0);
            }

            for(let i = 0; i < result.length; i++){
                if(result[i][0] == 'search'){
                    let query = result[i][1];
                    query = (query instanceof Array)? query[0]: query;
                    result.splice(i, 1, ['__SEARCH__', [query, searchFields]]);
                }else if(result[i][0] == 'planned_flag'){
                    if(state.get('source') == 'planned'){
                        result.splice(i, 1, ['planned_flag', 'Y']);
                    }else{
                        result.splice(i, 1, ['planned_flag', 'Y', '!=']);
                    }
                }else if(result[i][0] == 'planned_completion_date'){
                    let value = result[i][1];
                    value = (value instanceof Array)? value: [value, value];
                    let year = state.get('filter.year');
                    year = (year instanceof Array)? year[0]: year;
                    let s = new Date(year, value[0]-1, 1);
                    let e = new Date(year, value[1], 0);
                    result.splice(i, 1, ['planned_completion_date', [
                        s.getFullYear()+'-'+(('0'+(s.getMonth()+1)).slice(-2))+'-'+('0'+s.getDate()).slice(-2),
                        e.getFullYear()+'-'+(('0'+(e.getMonth()+1)).slice(-2))+'-'+('0'+e.getDate()).slice(-2)
                    ]]);
                }    
                if(result[i][1] && result[i][1] == '__NOT_EMPTY__'){
                    result.splice(i, 1, [result[i][0], '__EMPTY__', '!=']);
                }  
            }
        }

        return result;
    }

    processFilter(filter, separator='and'){

        let result = '';
        if(filter){
            let filterSql = '';
            // convert filter object to a query string: 
            if(! (filter instanceof Array)){
                let filarr = [];
                for(let key of Object.keys(filter)){
                    if(key.length > 6 && key.substring(0, 6) == 'group/'){

                        let value = this.processFilter(filter[key]['filters'], filter[key]['separator']);
                        filarr.push(value);
                        continue;
                    }
                    let value = filter[key];
                    if(! value){
                        continue;
                    }
                    if(! (value instanceof Array)){
                        value = [value];
                    }
                    // if(key == 'sdg'){
                    //     key = 'sdg_code';
                    // }
                    if(key == 'search'){
                        continue;
                        // let f = [];
                        // let words = value[0].trim().split(/('.*?'|".*?"|\S+)/g);
                        // for(let w of words){
                        //     if(w.trim() == ''){
                        //         continue;
                        //     }
                        //     w = w.replace(/'/g, '').replace(/"/g, '');
                        //     let f2 = [];
                        //     for(let sf of searchFields){
                        //         f2.push(sf + ' li \'' + w + '\'');
                        //     }
                        //     if(f2.length > 0){
                        //         f.push('(' + f2.join(' or ') + ')');
                        //     }
                        // }
                        // if(f.length > 0){
                        //     filarr.push('(' + f.join(' and ') + ')');
                        // }
                    }else if(key == 'planned_flag'){
                        if(state.get('source') == 'planned'){
                            filarr.push(key + ' eq \'Y\'');
                        }else{
                            filarr.push(key + ' ne \'Y\'');
                        }
                    }else if(key == 'planned_completion_date'){
                        let year = state.get('filter.year');
                        year = (year instanceof Array)? year[0]: year;
                        let s = new Date(year, value[0]-1, 1);
                        let e = new Date(year, value[1], 0);
                        let f = [];
                        f.push(key + ' ge \'' + s.getFullYear()+'-'+(('0'+(s.getMonth()+1)).slice(-2))+'-'+('0'+s.getDate()).slice(-2) + '\'');
                        f.push(key + ' le \'' + e.getFullYear()+'-'+(('0'+(e.getMonth()+1)).slice(-2))+'-'+('0'+e.getDate()).slice(-2) + '\'');
                        filarr.push('(' + f.join(' and ') + ')');
                    }else{
                        if(value.length == 1){
                            let op = 'eq';
                            if(value[0] instanceof Array){
                                op = value[0][0]=='!='? 'ne': 'eq'; // there are more options...
                                value[0] = value[0][1];
                            }
                            if(value[0] == '__NOT_EMPTY__'){
                                op = (op=='ne')? 'eq': 'ne';
                                value[0] = '__EMPTY__';
                            }
                            filarr.push(key + ' ' + op + ' \'' + (''+value[0]).replace(/'/g, '%27') + '\'');
                        }else if(value.length > 1){
                            let f = [];
                            for(let v of value){
                                if(v == '__NOT_EMPTY__'){
                                    // op = (op=='ne')? 'eq': 'ne';
                                    v = '__EMPTY__';
                                }
                                f.push(key + ' eq \'' + (''+v).replace(/'/g, '%27') + '\'');
                            }
                            filarr.push('(' + f.join(' or ') + ')');
                        }
                    } 
                }
                result = filarr.join(' ' + separator + ' ');
            }else{
                console.warn("filter is an array!");
            }

        }
        return result;
    }

    processSearch(input, filter){
        if(filter.hasOwnProperty('search')){
            const words = filter['search'].trim().split(/('.*?'|".*?"|\S+)/g);
            const line = [];
            for(let w of words){
                if(w.trim() == ''){
                    continue;
                }
                w = w.replace(/'/g, '').replace(/"/g, '');
                line.push(w);
            }
            if(line.length > 0){
                input['search'] = line.join(' ');
            }
        }
    }

}

export default AppModel;